import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { Fragment as r } from "react";
import { Transition as o, Dialog as t } from "@headlessui/react";
import { makeClassesByStyles as D } from "../../utils/classes.js";
import { ModalBackdrop as $ } from "./atoms/modal-backdrop/modal-backdrop.js";
import { ModalHeader as w } from "./atoms/modal-header/modal-header.js";
import i from "../../assets/b4665e63.modal.module.css";
const s = D(i), z = ({
  backdropClassName: d,
  children: f,
  className: y,
  copy: n,
  copyClassName: u,
  handleBackClick: h,
  handleCloseClick: c,
  hasBackdrop: v = !0,
  heading: l,
  enterFrom: N,
  enterTo: T,
  leaveFrom: F,
  leaveTo: x,
  headingClassName: M,
  isOpen: k,
  panelClassName: b,
  subheading: m,
  variant: j = "primary",
  onCloseComplete: p
}) => {
  const B = {};
  return /* @__PURE__ */ e(
    o,
    {
      as: r,
      appear: !0,
      show: k,
      afterLeave: () => {
        typeof p == "function" && p();
      },
      children: /* @__PURE__ */ a(
        t,
        {
          className: s("Modal", y),
          "data-sub-theme": B,
          onClose: () => {
          },
          children: [
            v && /* @__PURE__ */ e(
              o.Child,
              {
                as: r,
                enter: "ease-out duration-100",
                enterFrom: "opacity-0",
                enterTo: "opacity-100",
                leave: "ease-in duration-100",
                leaveFrom: "opacity-100",
                leaveTo: "opacity-0",
                children: /* @__PURE__ */ e(
                  $,
                  {
                    className: s("backdrop", d),
                    handleClick: c
                  }
                )
              }
            ),
            /* @__PURE__ */ e(
              o.Child,
              {
                as: r,
                enter: "ease-out duration-200",
                enterFrom: N ?? "opacity-0 transform-[scale(95%)]",
                enterTo: T ?? "opacity-100 transform-[scale(100%)]",
                leave: "ease-in duration-200",
                leaveFrom: F ?? "opacity-100 transform-[scale(100%)]",
                leaveTo: x ?? "opacity-0 transform-[scale(95%)]",
                children: /* @__PURE__ */ a(t.Panel, { className: `${s(i.panel)} ${b || ""}`, children: [
                  (!!l || !!m) && /* @__PURE__ */ e(
                    w,
                    {
                      className: M,
                      handleBackClick: h,
                      handleCloseClick: c,
                      heading: l,
                      subheading: m,
                      variant: j
                    }
                  ),
                  /* @__PURE__ */ a("div", { className: i.content, children: [
                    !!n && /* @__PURE__ */ e(t.Description, { className: u, children: n }),
                    f
                  ] })
                ] })
              }
            )
          ]
        }
      )
    }
  );
};
export {
  z as Modal
};
